const isExpired = (cache) => Date.now() - cache.cacheTime >= cache.maxAge;
export const saveToLocal = (data, key, maxAge) => {
    const cache = {
        cacheTime: Date.now(),
        maxAge,
        data,
    };
    sessionStorage.setItem(key, JSON.stringify(cache));
    return data;
};
export const fetchFromLocal = (key) => {
    const cacheString = sessionStorage.getItem(key);
    if (!cacheString)
        return;
    const cache = JSON.parse(cacheString);
    return !isExpired(cache) ? cache.data : undefined;
};
